import commonSetting from "@/config/commonSetting";
import api from "@/services/api/index";
import authApi from '@/utils/authApi';

import {Toast} from "antd-mobile";
import { Base64 } from 'js-base64';
import { createBrowserHistory } from 'history'


const browserHistory = createBrowserHistory();
const replaceTopic = (value) => {
  if(!value) {
      return
  }
  var r
    r = value.replace(/[#＃][^#＃]+[#＃]/g, function(word) {
      return `<a style="color:#1677FF" class="topic">${word}</a>`;
    });
    return r;
  // var _arr = value.replace(/＃/g, '#').split('#');
  // console.log(_arr)
  // if(_arr.length < 3) {
  //     return value
  // }else {
  //     var length = _arr.length;
  //     for (var i = 0; i <_arr.length ; i++) {
  //         if(i%2!=0 && i != length-1) {
  //             _arr[i] = '<span style="color:#1677FF">#' + _arr[i] + '#</span>'
  //         }
  //         if(length%2==0 && i == length-1) {
  //             _arr[i] = '#' + _arr[i]
  //         }
  //     }

  //     return _arr.join('').replace(new RegExp('\r?\n+','g'), '<br />')
  // }
};
const replaceText = (value) => {
  if (value) {
    return value.replace(/([A-Za-z0-9]{3})[A-Za-z0-9]{4}([A-Za-z0-9]{4})/g, '$1****$2');
  }
}
const fetchUserInfo = async () => {
  try {
    const resp = await api.userController.usersMeUsingGET();
    let userInfo = resp.data;
    return userInfo
  } catch (error) {
    console.log(error)
    return null
  }
};
const getWxAuthorizationUrl = async (path, productType, scope) => {
  let params =  {
      companyType: commonSetting.COMPANY_TYPE,
      productType: productType,
      scope: scope || 'snsapi_base',
      path: path
  }
  const resp = await authApi.getAuthorizeUrl(params);
  debugger
  if(resp.code == 0){
      return resp.data
  }else {
      console.log('授权链接获取失败:',resp.code)
      return null
  }
}
const n2oLink = async (origin,  path) => {
  debugger
  location.href = origin + 'n2o?path=' +  encodeURIComponent(path) + '&accountType=' +  localStorage.getItem('accountType') + '&openId=' + localStorage.getItem('openId') + '&wxId=' + localStorage.getItem('wxId')
}
const redirectWxAuthorizationUrl = async (path, productType, scope)=>{
  // return
  if(path.startsWith("/redirect")){
    Toast.show({
      icon: 'fail',
      content: '授权错误',
    })
    return
  }
  let url = await getWxAuthorizationUrl( encodeURIComponent(path), productType, scope);
  if(url){
    location.replace(url)
  }else {
    Toast.show({
      icon: 'fail',
      content: '未知错误',
    })
  }
}

const redirectProduct = async (domain,) => {
  let url = domain
  location.replace(url)
}
// 静态资源路劲
const fileUrlFilter = (url) => {
  if (url) {
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
      return url;
    } else {
      return 'https://tj-file-oss.cf69.com/' + url;
    }
  } else {
    return url;
  }
}

const hasKeyInArr = (arr, key, val) =>{
  for (const arrKey in arr) {
    if(arr[arrKey][key] === val){
      return arr[arrKey]
    }
  }
  return false
}

const parseAlign = (columns, direction)=>{
  return columns.map(item=>({...item, align:direction}))
}

const reqUploadTrackEvent = async (category, action, label, _wxId) => {
  let accessToken = localStorage.getItem('accessToken');
  let wxId
  if(accessToken){
    wxId = JSON.parse(Base64.decode(accessToken.split('.')[1]))?.["wxId"]
  }
  let params =  {
    category: category,
    action: action,
    label: label,
    number: localStorage.getItem('salesNumber'),
    wxId: _wxId || wxId
  }
  const resp = await api.wxTrackController.userWxTrackWxIdUsingPOST(params);
  if(resp.code == 0){
    return resp.data
  }else {
    console.log('授权链接获取失败:',resp.code)
    return null
  }
}
const reqUploadTrackEventCNZZ = async (category, action, label, cb) => {
  console.log("window._czc",window._czc)
  window._czc && window._czc.push(['_trackEvent', category, action, label])
  if(cb){
    setTimeout(()=>{
      cb()
    }, 100)
  }

}
const customNumber = (value) => {
  return value != null ? value.toFixed(2) : '--'; //convert to int
}
const stockClass = (val, toFixedNum) => {
  if(toFixedNum){
    val = Number(val.toFixed(toFixedNum))
  }
  if(val === 'NaN') return
  return val ? val > 0 ? 'stock-red' : 'stock-green' : ''
}
const stockBorderClass = (val, toFixedNum) => {
  if(toFixedNum){
    val = Number(val.toFixed(toFixedNum))
  }
  if(val === 'NaN') return
  return val ? val > 0 ? 'stock-red-border' : 'stock-green-border' : ''
}
const replaceId = (id) => {
  if (!id) {
    return ''
  }
  const str = `${id}`
  const map = {
    '0': 'J',
    '1': 'A',
    '2': 'B',
    '3': 'C',
    '4': 'D',
    '5': 'E',
    '6': 'F',
    '7': 'G',
    '8': 'H',
    '9': 'I'
  }
  return str.split('').map(item => map[item]).join('')
}
const numberChinese = (number) => {
  var units = '个十百千万@#%亿^&~', chars = '零一二三四五六七八九';
  var a = (number + '').split(''), s = []
  if (a.length > 12) {
    throw new Error('too big');
  } else {
    for (var i = 0, j = a.length - 1; i <= j; i++) {
      if (j == 1 || j == 5 || j == 9) {//两位数 处理特殊的 1*
        if (i == 0) {
          if (a[i] != '1') s.push(chars.charAt(a[i]));
        } else {
          s.push(chars.charAt(a[i]));
        }
      } else {
        s.push(chars.charAt(a[i]));
      }
      if (i != j) {
        s.push(units.charAt(j - i));
      }
    }
  }
  //return s;
  return s.join('').replace(/零([十百千万亿@#%^&~])/g, function (m, d, b) {//优先处理 零百 零千 等
    b = units.indexOf(d);
    if (b != -1) {
      if (d == '亿') return d;
      if (d == '万') return d;
      if (a[j - b] == '0') return '零'
    }
    return '';
  }).replace(/零+/g, '零').replace(/零([万亿])/g, function (m, b) {// 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
    return b;
  }).replace(/亿[万千百]/g, '亿').replace(/[零]$/, '').replace(/[@#%^&~]/g, function (m) {
    return { '@': '十', '#': '百', '%': '千', '^': '十', '&': '百', '~': '千' }[m];
  }).replace(/([亿万])([一-九])/g, function (m, d, b, c) {
    c = units.indexOf(d);
    if (c != -1) {
      if (a[j - c] == '0') return d + '零' + b
    }
    return m;
  });
}
const getRootDomain = (hostname) => {
  const domainParts = hostname.split('.');

  if (domainParts.length <= 2) {
    return hostname;
  }

  const tld = domainParts.slice(-2).join('.');
  return tld;
};

export default {
  browserHistory,
  replaceTopic,
  replaceText,
  n2oLink,
  parseAlign,
  fetchUserInfo,
  redirectProduct,
  getWxAuthorizationUrl,
  redirectWxAuthorizationUrl,
  hasKeyInArr,
  reqUploadTrackEvent,
  reqUploadTrackEventCNZZ,
  stockClass,
  stockBorderClass,
  customNumber,
  numberChinese,
  fileUrlFilter,
  replaceId,
  getRootDomain
}
